import React, { useState, useReducer } from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
  FaFacebook,
  FaLinkedin,
  FaInstagram,
  FaYoutube,
  FaClock,
  FaUser,
  FaPaperPlane,
  FaHeart,
  FaStar,
  FaShieldAlt,
  FaHeadset,
  FaGlobe,
} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import generalApi from "../api/generalApi";

const formReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_FIELD":
      return { ...state, [action.field]: action.value };
    case "RESET":
      return initialState;
    default:
      return state;
  }
};

const initialState = {
  fullName: "",
  email: "",
  phone: "",
  subject: "general",
  message: "",
};

const ContactUs = () => {
  const [formState, dispatch] = useReducer(formReducer, initialState);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (!formState.fullName) newErrors.fullName = "Name is required";
    if (
      !formState.email ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formState.email)
    ) {
      newErrors.email = "Valid email is required";
    }
    if (!formState.phone) newErrors.phone = "Phone number is required";
    if (!formState.message) newErrors.message = "Message is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);
      try {
        const result = await generalApi.submitContactMessage(formState);
        if (result.success) {
          toast.success(result.message || "Message sent successfully!");
          dispatch({ type: "RESET" });
        } else {
          toast.error(result.message || "Failed to send message. Please try again.");
        }
      } catch (error) {
        toast.error("Failed to send message. Please try again.");
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#2E2E2E",
        background: "linear-gradient(135deg, #F5F5F5 0%, #FFFFFF 100%)",
        minHeight: "100vh",
        overflow: "hidden",
        marginTop: "50px",
      }}
    >
      {/* Enhanced Header Section */}
      <section
        style={{
          padding:
            "clamp(30px, 8vw, 50px) clamp(15px, 3vw, 20px) clamp(20px, 5vw, 30px) clamp(15px, 3vw, 20px)",
          textAlign: "center",
          background: "linear-gradient(135deg, #F5F5F5 0%, #FFFFFF 100%)",
          position: "relative",
        }}
      >
        {/* Decorative Elements */}
        <div
          style={{
            position: "absolute",
            top: "20px",
            right: "10%",
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            background:
              "linear-gradient(135deg, rgba(238, 46, 36, 0.1) 0%, rgba(255, 196, 0, 0.1) 100%)",
            filter: "blur(20px)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "30px",
            left: "15%",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            background:
              "linear-gradient(135deg, rgba(255, 196, 0, 0.15) 0%, rgba(238, 46, 36, 0.1) 100%)",
            filter: "blur(15px)",
          }}
        />

        <div
          style={{
            maxWidth: "800px",
            margin: "0 auto",
            position: "relative",
            zIndex: 1,
          }}
        >
          <h1
            style={{
              fontSize: "clamp(2rem, 5vw, 2.8rem)",
              fontWeight: "800",
              background: "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              color: "transparent",
              marginBottom: "10px",
              letterSpacing: "-0.8px",
              textShadow: "0 2px 20px rgba(238, 46, 36, 0.1)",
            }}
          >
            Contact Us
          </h1>
          <p
            style={{
              fontSize: "0.95rem",
              color: "#2E2E2E",
              fontWeight: "500",
              margin: 0,
              opacity: 0.8,
              maxWidth: "600px",
              marginLeft: "auto",
              marginRight: "auto",
              lineHeight: "1.5",
            }}
          >
            We're here to help you create amazing experiences
          </p>
        </div>
      </section>

      {/* Contact Cards Section */}
      <section
        style={{
          padding:
            "clamp(20px, 5vw, 30px) clamp(15px, 3vw, 20px) clamp(30px, 6vw, 40px) clamp(15px, 3vw, 20px)",
          position: "relative",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* Enhanced Contact Methods Cards */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(min(100%, 250px), 1fr))",
              gap: "clamp(18px, 3.5vw, 24px)",
              marginBottom: "clamp(35px, 7vw, 50px)",
            }}
          >
            {[
              {
                icon: <FaPhone />,
                title: "Call Us",
                subtitle: "Speak with our team",
                details: "+91 9257734350",
                color: "#EE2E24",
                bgGradient:
                  "linear-gradient(135deg, rgba(238, 46, 36, 0.1) 0%, rgba(238, 46, 36, 0.05) 100%)",
              },
              {
                icon: <FaEnvelope />,
                title: "Email Us",
                subtitle: "Send us a message",
                details: "booktrivana@gmail.com",
                color: "#FFC400",
                bgGradient:
                  "linear-gradient(135deg, rgba(255, 196, 0, 0.1) 0%, rgba(255, 196, 0, 0.05) 100%)",
              },
              {
                icon: <FaMapMarkerAlt />,
                title: "Visit Us",
                subtitle: "Our location",
                details: "Sonegiri Kua near kotegate, Bikaner, Rajasthan",
                color: "#EE2E24",
                bgGradient:
                  "linear-gradient(135deg, rgba(238, 46, 36, 0.1) 0%, rgba(255, 196, 0, 0.05) 100%)",
              },
            ].map((contact, index) => (
              <div
                key={index}
                style={{
                  background: "#FFFFFF",
                  padding: "clamp(20px, 4vw, 32px) clamp(18px, 3.5vw, 28px)",
                  borderRadius: "16px",
                  textAlign: "center",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  border: "1px solid rgba(238, 46, 36, 0.1)",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow =
                    "0 12px 30px rgba(238, 46, 36, 0.15)";
                  e.currentTarget.style.borderColor = contact.color;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 20px rgba(0,0,0,0.06)";
                  e.currentTarget.style.borderColor = "rgba(238, 46, 36, 0.1)";
                }}
              >
                {/* Background Gradient on Hover */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: contact.bgGradient,
                    opacity: 0,
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                  }}
                  className="hover-bg"
                />

                <div style={{ position: "relative", zIndex: 1 }}>
                  <div
                    style={{
                      fontSize: "clamp(1.8rem, 5vw, 2.2rem)",
                      color: contact.color,
                      marginBottom: "clamp(12px, 3vw, 16px)",
                      display: "inline-flex",
                      padding: "clamp(12px, 3vw, 16px)",
                      background: contact.bgGradient,
                      borderRadius: "50%",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    {contact.icon}
                  </div>
                  <h3
                    style={{
                      fontSize: "clamp(1rem, 2.5vw, 1.15rem)",
                      fontWeight: "700",
                      color: "#2E2E2E",
                      marginBottom: "clamp(4px, 1.5vw, 6px)",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    {contact.title}
                  </h3>
                  <p
                    style={{
                      color: "#2E2E2E",
                      fontSize: "clamp(0.8rem, 2vw, 0.85rem)",
                      marginBottom: "clamp(8px, 2vw, 12px)",
                      opacity: 0.6,
                      fontWeight: "500",
                    }}
                  >
                    {contact.subtitle}
                  </p>
                  <p
                    style={{
                      color: contact.color,
                      fontSize: "clamp(0.9rem, 2.2vw, 1rem)",
                      fontWeight: "700",
                      wordBreak: "break-word",
                    }}
                  >
                    {contact.details}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Main Contact Form and Info Grid */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(min(100%, 400px), 1fr))",
              gap: "clamp(20px, 4vw, 35px)",
              alignItems: "start",
            }}
          >
            {/* Enhanced Premium Contact Form */}
            <div
              style={{
                background: "#FFFFFF",
                borderRadius: "20px",
                padding: "clamp(20px, 5vw, 40px)",
                border: "1px solid rgba(238, 46, 36, 0.1)",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Decorative Corner Element */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "150px",
                  height: "150px",
                  background:
                    "linear-gradient(135deg, rgba(238, 46, 36, 0.05) 0%, rgba(255, 196, 0, 0.05) 100%)",
                  borderRadius: "0 0 0 100%",
                }}
              />

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  marginBottom: "28px",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
                    borderRadius: "10px",
                    padding: "10px",
                    color: "white",
                    boxShadow: "0 4px 15px rgba(238, 46, 36, 0.3)",
                  }}
                >
                  <FaPaperPlane style={{ fontSize: "1.1rem" }} />
                </div>
                <div>
                  <h2
                    style={{
                      fontSize: "clamp(1.1rem, 3vw, 1.35rem)",
                      fontWeight: "800",
                      color: "#2E2E2E",
                      margin: 0,
                      letterSpacing: "-0.5px",
                    }}
                  >
                    Send us a Message
                  </h2>
                  <p
                    style={{
                      color: "#2E2E2E",
                      fontSize: "clamp(0.8rem, 2vw, 0.85rem)",
                      margin: "4px 0 0 0",
                      opacity: 0.6,
                      fontWeight: "500",
                    }}
                  >
                    We'd love to hear from you
                  </p>
                </div>
              </div>

              <form
                onSubmit={handleSubmit}
                style={{
                  display: "grid",
                  gap: "20px",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fit, minmax(min(100%, 200px), 1fr))",
                    gap: "clamp(12px, 3vw, 18px)",
                  }}
                >
                  <div>
                    <input
                      type="text"
                      placeholder="Full Name"
                      value={formState.fullName}
                      onChange={(e) =>
                        dispatch({
                          type: "UPDATE_FIELD",
                          field: "fullName",
                          value: e.target.value,
                        })
                      }
                      style={{
                        width: "100%",
                        padding:
                          "clamp(12px, 2.5vw, 14px) clamp(14px, 3vw, 18px)",
                        borderRadius: "10px",
                        border: "2px solid #E8E8E8",
                        fontSize: "clamp(0.9rem, 2vw, 0.95rem)",
                        background: "#FAFAFA",
                        transition: "all 0.3s ease",
                        outline: "none",
                        fontWeight: "500",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#EE2E24";
                        e.target.style.background = "#FFFFFF";
                        e.target.style.boxShadow =
                          "0 0 0 4px rgba(238, 46, 36, 0.08)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#E8E8E8";
                        e.target.style.background = "#FAFAFA";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                    {errors.fullName && (
                      <p
                        style={{
                          color: "#EE2E24",
                          marginTop: "6px",
                          fontSize: "0.8rem",
                          fontWeight: "600",
                        }}
                      >
                        {errors.fullName}
                      </p>
                    )}
                  </div>
                  <div>
                    <input
                      type="email"
                      placeholder="Email Address"
                      value={formState.email}
                      onChange={(e) =>
                        dispatch({
                          type: "UPDATE_FIELD",
                          field: "email",
                          value: e.target.value,
                        })
                      }
                      style={{
                        width: "100%",
                        padding:
                          "clamp(12px, 2.5vw, 14px) clamp(14px, 3vw, 18px)",
                        borderRadius: "10px",
                        border: "2px solid #E8E8E8",
                        fontSize: "clamp(0.9rem, 2vw, 0.95rem)",
                        background: "#FAFAFA",
                        transition: "all 0.3s ease",
                        outline: "none",
                        fontWeight: "500",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#EE2E24";
                        e.target.style.background = "#FFFFFF";
                        e.target.style.boxShadow =
                          "0 0 0 4px rgba(238, 46, 36, 0.08)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#E8E8E8";
                        e.target.style.background = "#FAFAFA";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                    {errors.email && (
                      <p
                        style={{
                          color: "#EE2E24",
                          marginTop: "6px",
                          fontSize: "0.8rem",
                          fontWeight: "600",
                        }}
                      >
                        {errors.email}
                      </p>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fit, minmax(min(100%, 200px), 1fr))",
                    gap: "clamp(12px, 3vw, 18px)",
                  }}
                >
                  <div>
                    <input
                      type="tel"
                      placeholder="Phone Number"
                      value={formState.phone}
                      onChange={(e) =>
                        dispatch({
                          type: "UPDATE_FIELD",
                          field: "phone",
                          value: e.target.value,
                        })
                      }
                      style={{
                        width: "100%",
                        padding:
                          "clamp(12px, 2.5vw, 14px) clamp(14px, 3vw, 18px)",
                        borderRadius: "10px",
                        border: "2px solid #E8E8E8",
                        fontSize: "clamp(0.9rem, 2vw, 0.95rem)",
                        background: "#FAFAFA",
                        transition: "all 0.3s ease",
                        outline: "none",
                        fontWeight: "500",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#EE2E24";
                        e.target.style.background = "#FFFFFF";
                        e.target.style.boxShadow =
                          "0 0 0 4px rgba(238, 46, 36, 0.08)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#E8E8E8";
                        e.target.style.background = "#FAFAFA";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                    {errors.phone && (
                      <p
                        style={{
                          color: "#EE2E24",
                          marginTop: "6px",
                          fontSize: "0.8rem",
                          fontWeight: "600",
                        }}
                      >
                        {errors.phone}
                      </p>
                    )}
                  </div>
                  <div>
                    <select
                      value={formState.subject}
                      onChange={(e) =>
                        dispatch({
                          type: "UPDATE_FIELD",
                          field: "subject",
                          value: e.target.value,
                        })
                      }
                      style={{
                        width: "100%",
                        padding:
                          "clamp(12px, 2.5vw, 14px) clamp(14px, 3vw, 18px)",
                        borderRadius: "10px",
                        border: "2px solid #E8E8E8",
                        fontSize: "clamp(0.9rem, 2vw, 0.95rem)",
                        background: "#FAFAFA",
                        transition: "all 0.3s ease",
                        outline: "none",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#EE2E24";
                        e.target.style.background = "#FFFFFF";
                        e.target.style.boxShadow =
                          "0 0 0 4px rgba(238, 46, 36, 0.08)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#E8E8E8";
                        e.target.style.background = "#FAFAFA";
                        e.target.style.boxShadow = "none";
                      }}
                    >
                      <option value="general">General Inquiry</option>
                      <option value="booking">
                        Hotel & Restaurant Booking
                      </option>
                      <option value="feedback">Feedback & Suggestions</option>
                      <option value="support">Customer Support</option>
                    </select>
                  </div>
                </div>

                <div>
                  <textarea
                    placeholder="Tell us how we can help you..."
                    value={formState.message}
                    onChange={(e) =>
                      dispatch({
                        type: "UPDATE_FIELD",
                        field: "message",
                        value: e.target.value,
                      })
                    }
                    rows="5"
                    style={{
                      width: "100%",
                      padding:
                        "clamp(12px, 2.5vw, 14px) clamp(14px, 3vw, 18px)",
                      borderRadius: "10px",
                      border: "2px solid #E8E8E8",
                      fontSize: "clamp(0.9rem, 2vw, 0.95rem)",
                      background: "#FAFAFA",
                      transition: "all 0.3s ease",
                      outline: "none",
                      resize: "vertical",
                      minHeight: "120px",
                      fontWeight: "500",
                      fontFamily: "inherit",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#EE2E24";
                      e.target.style.background = "#FFFFFF";
                      e.target.style.boxShadow =
                        "0 0 0 4px rgba(238, 46, 36, 0.08)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#E8E8E8";
                      e.target.style.background = "#FAFAFA";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                  {errors.message && (
                    <p
                      style={{
                        color: "#EE2E24",
                        marginTop: "6px",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                      }}
                    >
                      {errors.message}
                    </p>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    width: "100%",
                    background: isSubmitting
                      ? "linear-gradient(135deg, #BDBDBD 0%, #9E9E9E 100%)"
                      : "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
                    color: "#fff",
                    fontWeight: "700",
                    fontSize: "clamp(0.9rem, 2.2vw, 1rem)",
                    border: "none",
                    borderRadius: "10px",
                    padding: "clamp(12px, 3vw, 16px) 0",
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                    boxShadow: "0 6px 20px rgba(238, 46, 36, 0.3)",
                    transition: "all 0.3s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    letterSpacing: "0.3px",
                  }}
                  onMouseEnter={(e) => {
                    if (!isSubmitting) {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 8px 25px rgba(238, 46, 36, 0.4)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSubmitting) {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 6px 20px rgba(238, 46, 36, 0.3)";
                    }
                  }}
                >
                  {isSubmitting ? (
                    <>
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          border: "2px solid #ffffff",
                          borderTop: "2px solid transparent",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                        }}
                      />
                      Sending...
                    </>
                  ) : (
                    <>
                      <FaPaperPlane />
                      Send Message
                    </>
                  )}
                </button>
              </form>
            </div>

            {/* Additional Information Sidebar */}
            <div>
              {/* Business Hours */}
              <div
                style={{
                  background: "#FFFFFF",
                  borderRadius: "12px",
                  padding: "clamp(18px, 4vw, 24px)",
                  marginBottom: "clamp(15px, 3vw, 20px)",
                  border: "1px solid #F5F5F5",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "16px",
                  }}
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
                      borderRadius: "8px",
                      padding: "8px",
                      color: "white",
                    }}
                  >
                    <FaClock style={{ fontSize: "1.1rem" }} />
                  </div>
                  <h3
                    style={{
                      fontSize: "1.15rem",
                      fontWeight: "700",
                      color: "#2E2E2E",
                      margin: 0,
                      letterSpacing: "-0.3px",
                    }}
                  >
                    Business Hours
                  </h3>
                </div>
                <div
                  style={{
                    color: "#2E2E2E",
                    lineHeight: "1.7",
                    fontSize: "0.85rem",
                  }}
                >
                  <p
                    style={{
                      margin: "6px 0",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ fontWeight: "600" }}>All Days:</span>
                    <span style={{ opacity: 0.8 }}>10:00 AM - 10:00 PM</span>
                  </p>
                </div>
              </div>

              {/* Why Choose Us */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
                  borderRadius: "12px",
                  padding: "24px",
                  color: "white",
                  marginBottom: "20px",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.15rem",
                    fontWeight: "700",
                    marginBottom: "16px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    letterSpacing: "-0.3px",
                  }}
                >
                  <FaHeart />
                  Why Choose Trivana?
                </h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {[
                    { icon: <FaStar />, text: "5-Star Service Quality" },
                    { icon: <FaShieldAlt />, text: "100% Secure Booking" },
                    { icon: <FaHeadset />, text: "24/7 Customer Support" },
                    { icon: <FaGlobe />, text: "Global Network" },
                  ].map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        fontSize: "0.85rem",
                      }}
                    >
                      <span style={{ fontSize: "0.9rem", opacity: 0.95 }}>
                        {item.icon}
                      </span>
                      <span>{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Social Media Links */}
              <div
                style={{
                  background: "#FFFFFF",
                  borderRadius: "12px",
                  padding: "24px",
                  border: "1px solid #F5F5F5",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.15rem",
                    fontWeight: "700",
                    color: "#2E2E2E",
                    marginBottom: "16px",
                    letterSpacing: "-0.3px",
                  }}
                >
                  Follow Us
                </h3>
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    justifyContent: "center",
                  }}
                >
                  {[
                    {
                      icon: <FaFacebook />,
                      color: "#1877f2",
                      name: "Facebook",
                      url: "https://www.facebook.com/profile.php?id=61574583771198",
                    },
                    {
                      icon: <FaInstagram />,
                      color: "#e4405f",
                      name: "Instagram",
                      url: "https://www.instagram.com/trivanahospitality?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
                    },
                    {
                      icon: <FaLinkedin />,
                      color: "#0077b5",
                      name: "LinkedIn",
                      url: "https://www.linkedin.com/company/trivana-hospitality/posts/?feedView=all",
                    },
                    {
                      icon: <FaYoutube />,
                      color: "#ff0000",
                      name: "YouTube",
                      url: "https://www.youtube.com/@TrivanaHospitality",
                    },
                  ].map((social) => (
                    <a
                      key={social.name}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "44px",
                        height: "44px",
                        borderRadius: "10px",
                        background: `${social.color}15`,
                        color: social.color,
                        fontSize: "1.3rem",
                        transition: "all 0.3s ease",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = social.color;
                        e.target.style.color = "white";
                        e.target.style.transform = "translateY(-3px)";
                        e.target.style.boxShadow = `0 6px 16px ${social.color}40`;
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = `${social.color}15`;
                        e.target.style.color = social.color;
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "none";
                      }}
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/919257734350"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
          padding: "18px",
          borderRadius: "50%",
          boxShadow: "0 8px 25px rgba(37, 211, 102, 0.3)",
          zIndex: 1000,
          transition: "all 0.3s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = "scale(1.1) translateY(-2px)";
          e.target.style.boxShadow = "0 12px 35px rgba(37, 211, 102, 0.4)";
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "scale(1) translateY(0)";
          e.target.style.boxShadow = "0 8px 25px rgba(37, 211, 102, 0.3)";
        }}
      >
        <FaWhatsapp style={{ color: "#fff", fontSize: "1.8rem" }} />
      </a>

      {/* Custom CSS for spinner animation */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default ContactUs;
